import React from 'react';
import { Outlet } from 'react-router-dom';
import { Spinner, Center } from '@chakra-ui/react';
import { useAuthInfo, useRedirectFunctions } from '@propelauth/react';
import { UserSync } from './auth/UserSync';

interface ProtectedRouteProps {
  redirectPath?: string;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = () => {
  const { loading, isLoggedIn } = useAuthInfo();
  const { redirectToLoginPage } = useRedirectFunctions();

  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (!isLoggedIn) {
    // Use PropelAuth's built-in redirect function
    redirectToLoginPage();
    return null;
  }

  return (
    <>
      <UserSync />
      <Outlet />
    </>
  );
};
